"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user_group.list': 'Gruppi di Utenti',
    'route.user_group.create': 'Aggiungi Gruppo di Utenti',
};
